import {
  USER_LOGIN, LOGIN_SUCCESS, LOGIN_ERROR, RESET_LOGIN, FIRST_LOGIN, UPDATE_USER
} from './Actions';
import { initialState } from './UserContext';

const UserReducer = (state, action) => {
  switch (action.type) {
    case USER_LOGIN:
      return { ...state, status: 'loading' };
    case FIRST_LOGIN:
      return {
        ...state,
        firstLogin: {
          isFirstLogin: action.isFirstLogin, 
          tmpToken: action.token, 
          tmpUser: action.user,
        },
        role: action.role,
        status: 'success',
      };
    case LOGIN_SUCCESS:
      localStorage.setItem('token', action.token);
      localStorage.setItem('user', JSON.stringify(action.user));
      localStorage.setItem('role', action.user?.role);
      return {
        ...state, user: action.user, token: action.token, role: action.user?.role, status: 'success',
      };
    case LOGIN_ERROR:
      return { ...state, status: 'error', errorMessage: action.message };
    case RESET_LOGIN:
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('role');
      return initialState;
    case UPDATE_USER:
      return {
        ...state,
        user: action.user,
        role: action.user?.role ?? state.role,
      };
    default:
      return state;
  }
};

export default UserReducer;
